import {SHA512} from './payment-model.js';

export const createReq = (data, orders,isAppliedCoupon) => {
  let discount_amount = 0
  if(isAppliedCoupon){
    discount_amount = isAppliedCoupon/orders.length
  }
  if (Object.keys(data).length > 0) {
    let _mid =  data.payment_providers.merchant_id;
    let _requestid = data.payment_data.payment_id;
    let _ipaddress =  data.payment_data.client_ip;
    let _noturl =  data.payment_providers.notification_url; //'http://localhost:3000/paynamics_notification'; //
    let _resurl =`${window.location.origin}/processing?status=successful` ; //'http://localhost:3000/paynamics-success';//
    let _cancelurl = `${window.location.origin}/processing?status==failed`; //'http://localhost:3000/paynamics-faileds';//
    let _mtac_URL =  data.payment_providers.m_tandc_url;
    let _desc =  data.payment_data.description;
    let _fname =  data.payment_data.name;
    let _lname =  data.payment_data.lname;
    let _mname = '';
    let _addr1 =  data.payment_data.address1;
    let _addr2 = '';
    let _city =  data.payment_data.city;
    let _state =  data.payment_data.state;
    let _country =  data.payment_data.country;
    let _zip =  data.payment_data.zip;
    let _email =  data.payment_data.email;
    let _phone =
       data.payment_data.phone === null ? '-' : data.payment_data.phone;
    let _clientip =  data.payment_data.client_ip;
    let _amount =  Number(data.payment_data.amount).toFixed(2);
    let _currency =  data.payment_data.currency;
    let _sec3d = 'try3d';
    let _pmethod = '';
    let _mlogo_URL = '';
    let _trxtype = 'sale';
    let _mobile =
       data.payment_data.phone === null ? '-' : data.payment_data.phone;
    let _key =  data.payment_providers.key;
    let forSign =
      _mid +
      _requestid +
      _ipaddress +
      _noturl +
      _resurl +
      _fname +
      _lname +
      _mname +
      _addr1 +
      _addr2 +
      _city +
      _state +
      _country +
      _zip +
      _email +
      _phone +
      _clientip +
      _amount +
      _currency +
      _sec3d;
    let _sign = SHA512(forSign + _key);
    let strxml = '';

    strxml = strxml + '<?xml version="1.0" encoding="utf-8" ?>';
    strxml = strxml + '<Request>';
    strxml = strxml + '<orders>';
    strxml = strxml + '<items>';

    let orderStr = '';
    for (const order of orders) {
      const grandTotal = (order.totalPrice - order.lessCWT) - discount_amount;
      orderStr += `<Items><itemname>${order.product.products_master.name}</itemname><quantity>${order.inputValue}</quantity><amount>${grandTotal / order.inputValue}</amount></Items>`;
      console.log('ORDERSTRING: ', grandTotal / order.inputValue, grandTotal, order.inputValue);
      console.log('ORDERSTRING: ', _amount);
    }
    

    strxml = strxml + orderStr;
    strxml = strxml + '</items>';
    strxml = strxml + '</orders>';
    strxml = strxml + '<mid>' + _mid + '</mid>';
    strxml = strxml + '<request_id>' + _requestid + '</request_id>';
    strxml = strxml + '<ip_address>' + _ipaddress + '</ip_address>';
    strxml = strxml + '<notification_url>' + _noturl + '</notification_url>';
    strxml = strxml + '<response_url>' + _resurl + '</response_url>';
    strxml = strxml + '<cancel_url>' + _cancelurl + '</cancel_url>';
    strxml = strxml + '<mtac_url>' + _mtac_URL + '</mtac_url>';
    strxml = strxml + '<descriptor_note>' + _desc + '</descriptor_note>';
    strxml = strxml + '<fname>' + _fname + '</fname>';
    strxml = strxml + '<lname>' + _lname + '</lname>';
    strxml = strxml + '<mname>' + _mname + '</mname>';
    strxml = strxml + '<address1>' + _addr1 + '</address1>';
    strxml = strxml + '<address2>' + _addr2 + '</address2>';
    strxml = strxml + '<city>' + _city + '</city>';
    strxml = strxml + '<state>' + _state + '</state>';
    strxml = strxml + '<country>' + _country + '</country>';
    strxml = strxml + '<zip>' + _zip + '</zip>';
    strxml = strxml + '<secure3d>' + _sec3d + '</secure3d>';
    strxml = strxml + '<trxtype>' + _trxtype + '</trxtype>';
    strxml = strxml + '<email>' + _email + '</email>';
    strxml = strxml + '<phone>' + _phone + '</phone>';
    strxml = strxml + '<mobile>' + _mobile + '</mobile>';
    strxml = strxml + '<client_ip>' + _clientip + '</client_ip>';
    strxml = strxml + '<amount>' + _amount + '</amount>';
    strxml = strxml + '<currency>' + _currency + '</currency>';
    strxml = strxml + '<mlogo_url>' + _mlogo_URL + '</mlogo_url>';
    strxml = strxml + '<pmethod>' + _pmethod + '</pmethod>';
    strxml = strxml + '<signature>' + _sign + '</signature>';
    strxml = strxml + '</Request>';
    return strxml;
  }
};

